import { Input, MessageBanner, theme, typographyRem } from '@by-miles/bymiles-styles'
import React from 'react'

import { ToolTip } from '../../../../ToolTip'
const { h5: H5, paragraphBody: ParagraphBody } = typographyRem

interface GenericContactQuestionProps {
  question: string
  questionInfo: string
  messageBanner?: string
  error?: string
  value: string
  name: string
  placeholder: string
  infoModalText?: string
  autoComplete?: string
  onChange: (value: string) => void
  onBlur: () => void
  setError: (value: string) => void
  setValue: (value: string) => void
  showModal: boolean
}

export const GenericContactQuestion = ({
  question,
  messageBanner,
  questionInfo,
  onBlur,
  onChange,
  value,
  name,
  placeholder,
  error,
  setError,
  setValue,
  infoModalText,
  autoComplete,
  showModal,
}: GenericContactQuestionProps) => (
  <div className="question-container" id={name === 'email' ? name : 'mobileNumber'}>
    <div className="question-text-container">
      <H5>{question}</H5>
      <ParagraphBody className="question-info">{questionInfo}</ParagraphBody>
    </div>
    <div className="input-info-container">
      <Input
        placeHolder={placeholder}
        name={name}
        value={value}
        onChange={value => {
          setError('')
          setValue(value)
          onChange(value)
        }}
        autoComplete={autoComplete || 'off'}
        error={error}
        onBlur={onBlur}
        dataCy={`${name}-input`}
        valid={(value && !error) || false}
        className={`input-input ${name}`}
        type={name === 'email' ? '*' : 'number'}
        tabFocusTrap={showModal ? -1 : 0}
        ariaLiveOnFocus
      />
      {infoModalText && (
        <ToolTip text={infoModalText} className="tool-tip tip-top-small" tabFocusTrap={showModal ? -1 : 0} />
      )}
    </div>
    {messageBanner && (
      <MessageBanner
        className="email-message banner-message"
        backgroundColor={theme.tints.lightAubergine}
        borderColor={theme.primaryColours.aubergine.main}
        text={<span>{messageBanner}</span>}
      />
    )}
  </div>
)
